<template>
  <div>
    <div
      v-if="loadError"
      class="wrapper mt-3">
      <f-alert
        theme="warning"
        visible
        class="my-4">
        {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
      </f-alert>
    </div>
    <template v-else>
    <f-tabs
      :items="tabItems" small>
      <div slot="tab-0">
        <account-package-details
          v-if="allDataLoaded"
          :account-valid-days="data && data.account_valid_days ? data.account_valid_days : 0"
          :available-packages="allPackages"
          :current-package-id="data && data.package ? data.package.id : 0"
          :has-valid-account="hasValidAccount" />
      </div>
      <div slot="tab-1">
        <settlements-list v-if="hasValidAccount"/>
        <f-alert
          v-else
          visible
          class="my-3"
          theme="inactive">
          <span>
          {{ $t('settlements.sectionAvailableForActiveUsers') }}
          </span>
        </f-alert>
      </div>
    </f-tabs>
    <div
      v-if="!allDataLoaded"
      class="loading-spinner-wrapper">
      <div class="loading-spinner pb-3 pt-3">
        <span class="loading-spinner-content">
          {{ $t('ui.loadingDataInProgress') }}&hellip;
        </span>
      </div>
    </div>
  </template>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import AccountPackageDetails from '@/views/forms/settlements/AccountPackageDetails.vue';
import SettlementsList from '@/views/forms/settlements/SettlementsList.vue';

export default {
  name: 'settlements',
  components: {
    'account-package-details': AccountPackageDetails,
    'settlements-list': SettlementsList
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.allPackagesLoaded;
    }
  },
  data () {
    return {
      allPackages: [],
      allPackagesLoaded: false,
      data: {
        account_valid_days: 0,
        package: null
      },
      hasValidAccount: null,
      loaded: false,
      loadError: false,
      tabItems: [{
        title: this.$t('settlements.packages')
      }, {
        title: this.$t('settlements.paymentHistory')
      }]
    };
  },
  mounted () {
    Vue.set(this, 'hasValidAccount', this.$store.getters['getUserHasValidAccount']);
    this.$bus.$on('settlements-reload', this.loadAdvisorData);
    this.loadAdvisorData();
    this.loadPackagesData();
  },
  methods: {
    loadAdvisorData () {
      if (!this.hasValidAccount) {
        this.loaded = true;
        return;
      }

      Vue.set(this, 'loaded', false);
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/adviser/adviser/item',
        loadedKey: 'loaded',
        outputKey: 'data',
        pagination: false
      });
    },
    loadPackagesData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/packages/items',
        method: 'get',
        outputKey: 'allPackages',
        loadedKey: 'allPackagesLoaded',
        errorKey: 'loadError',
        params: {
          pagination: 0
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('settlements-reload', this.loadAdvisorData);
  }
};
</script>
